import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { GoPlus } from "react-icons/go";
import apiClient from "../../service/Axios";
import TeamMemberCreateModal from "./TeamMemberCreateModal";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-hot-toast";

const TeamDetailsModal = ({
  selectedTeam,
  detailsvisible,
  setDetailsVisible,
  setSelectedTeam,
  teamGetFuc,
}) => {
  const [visible, setVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [teamEmails, setTeamEmails] = useState([]);

  // console.log("selectedTeam", selectedTeam?.members[0].name);
  // console.log("selectedOption", selectedOption);

  useEffect(() => {
    if (selectedOption) {
      // Check if the selected member is already in the team
      if (
        selectedTeam?.members.some((member) => member.email === selectedOption)
      ) {
        toast.error("This member is already in the team.");
      } else {
        const apiUrl = `${process.env.REACT_APP_API}/user/teams/members`;
        apiClient
          .post(apiUrl, {
            team: selectedTeam?.id,
            member: selectedOption,
          })
          .then((response) => {
            console.log("Member added to the team:", response?.data);
            setDetailsVisible(false);
            setSelectedOption(" ");
            teamGetFuc();
          })
          .catch((error) => {
            console.error("Error adding member to the team:", error);
          });
      }
    }
  }, [selectedOption, selectedTeam]);

  useEffect(() => {
    apiClient
      .get(`${process.env.REACT_APP_AUTHENTICATION_API}/user/list`)
      .then((res) => {
        setTeamEmails(res?.data || []);
      });
  }, []);

  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <Dialog
      visible={detailsvisible}
      style={{
        width: "50vw",
        background: "#fff",
        color: "black",
        padding: "20px 30px",
        marginBottom: "20px",
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      }}
      onHide={() => {
        setDetailsVisible(false);
        setSelectedTeam(null);
      }}
      header={`${selectedTeam?.team} Team Details`}>
      <div className="flex justify-between items-center gap-8 mt-5">
        {selectedTeam && (
          <div>
            <p className="font-medium">
              Team Name: <span>{selectedTeam?.team}</span>
            </p>
          </div>
        )}
        <button
          className="hover:bg-[#161B22] bg-[#161b22d1] text-white font-normal py-2 px-4 rounded-md inline-flex items-center"
          onClick={() => setVisible(true)}>
          <GoPlus className="font-bold text-xl" />
          <span className="text-[14px] font-normal">Add New Member</span>
        </button>
      </div>
      <div>
        <p className="font-medium mt-7 mb-3">Select Member</p>
        <select
          value={selectedOption}
          onChange={handleDropdownChange}
          className="border border-gray-300 p-2 rounded-md">
          <option value="">Select a member</option>
          {teamEmails?.map((member) => (
            <option key={member?.email} value={member?.email}>
              {member?.name} - {member?.email}
            </option>
          ))}
        </select>
      </div>
      <div className="overflow-hidden">
        <p className="font-medium mt-7 mb-3 border-0 border-b border-gray-500">
          Team Members
        </p>

        <div className=" overflow-auto h-[400px]">
          <ul className="max-w-full divide-y divide-gray-200 dark:divide-gray-700 mx-4">
            {selectedTeam?.members?.map((e, i) => {
              return (
                <li className="pb-2 pt-3 sm:pb-4" key={i}>
                  <div className="flex items-center space-x-4 rtl:space-x-reverse">
                    <div className="flex-shrink-0">
                      <img
                        className="w-8 h-8 rounded-full"
                        src="https://as2.ftcdn.net/v2/jpg/03/64/21/11/1000_F_364211147_1qgLVxv1Tcq0Ohz3FawUfrtONzz8nq3e.jpg"
                        alt="Neil image"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                        {e?.name}
                      </p>
                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                        {e?.email}
                      </p>
                    </div>
                    <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                      <RxCross2 />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <TeamMemberCreateModal visible={visible} setVisible={setVisible} />
    </Dialog>
  );
};

export default TeamDetailsModal;
